module.exports = __webpack_public_path__ + "img/icon-delete.610b0027.svg";